"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowOverviewDTOConverter.
 * @author OPt
 */


var WindowItemPromoPriceDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowItemPromoPriceDTOConverter, _DataObjectConverter_);

  function WindowItemPromoPriceDTOConverter() {
    _classCallCheck(this, WindowItemPromoPriceDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemPromoPriceDTOConverter).apply(this, arguments));
  }

  return WindowItemPromoPriceDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowItemPromoPriceDTOConverter = WindowItemPromoPriceDTOConverter;